<template>
  <div class="Profile">
    <div class="Header">
      <h2>个人中心</h2>
    </div>
    
    <div class="Content">
      <div class="Section">
        <div class="SectionTitle">基本信息</div>
        <div class="InfoItem">
          <span class="Label">用户名：</span>
          <span class="Value">{{ userInfo.userName }}</span>
        </div>
        <div class="InfoItem">
          <span class="Label">昵称：</span>
          <span class="Value">{{ userInfo.nickname || '未设置' }}</span>
        </div>
        <div class="InfoItem">
          <span class="Label">邮箱：</span>
          <span class="Value">{{ userInfo.email || '未绑定' }}</span>
        </div>
        <div class="InfoItem">
          <span class="Label">注册时间：</span>
          <span class="Value">{{ FormatDate(userInfo.createTime) }}</span>
        </div>
      </div>
      
      <div class="Section">
        <div class="SectionTitle">账号安全</div>
        <div class="ActionItem" @click="ShowChangePwdDialog">
          <img src="/icon/password.svg" class="ActionIcon">
          <span>修改密码</span>
          <i class="iconfont icon-right"></i>
        </div>
        <div class="ActionItem" @click="ShowDeleteAccountDialog">
          <img src="/icon/delete.svg" class="ActionIcon">
          <span>注销账号</span>
          <i class="iconfont icon-right"></i>
        </div>
      </div>
    </div>

    <!-- 修改密码对话框 -->
    <Dialog v-if="control.dialog.state" 
      :title="control.dialog.title"
      :content="control.dialog.content"
      :icon="control.dialog.icon"
      :acceptName="control.dialog.buttonName.accept"
      :cancelName="control.dialog.buttonName.cancel"
      :accept="control.dialog.accept"
      @dialogCancel="control.dialog.state = false">
      
      <div v-if="control.dialog.name === 'ChangePwd'" class="Dialog_ChangePwd">
        <input v-model="changePwd.value.email" class="Input" placeholder="请输入邮箱">
        <div class="CodeRow" style="display: flex; gap: 10px;">
          <input v-model="changePwd.value.code" class="Input" placeholder="验证码" style="flex: 1;">
          <button class="SendCodeBtn" :disabled="countdown > 0" @click="SendResetCode">
            {{ countdown > 0 ? `${countdown}s` : '获取验证码' }}
          </button>
        </div>
        <input v-model="changePwd.value.newPwd" :disabled='changePwd.state'
          type="password" ref="NewPwd" 
          :placeholder="changePwd.placeholder.newPwd"
          @keydown.enter="KeydownEnter_ChangePwd">
        <input v-model="changePwd.value.checkPwd" :disabled='changePwd.state'
          type="password" ref="CheckPwd" 
          :placeholder="changePwd.placeholder.checkPwd"
          @keydown.enter="KeydownEnter_ChangePwd">
      </div>

      <div v-if="control.dialog.name === 'DeleteAccount'" class="Dialog_DeleteAccount">
        <div class="WarningText">
          此操作无法恢复，请输入“{{ deleteAccount.confirmText }}”确认注销。
        </div>
        <input v-model="deleteAccount.value" class="Input" 
          :placeholder="deleteAccount.confirmText"
          @keydown.enter="SubmitDeleteAccount">
      </div>
    </Dialog>
  </div>
</template>

<script>
import Dialog from '../components/Dialog.vue'

export default {
  name: 'Profile',
  components: { Dialog },
  data() {
    return {
      userInfo: { userName: '', nickname: '', email: '', createTime: '' },
      countdown: 0,
      timer: null,
      jumpTimer: null,
      control: {
        dialog: {
          state: false,
          title: '',
          content: '',
          icon: '',
          buttonName: { accept: '', cancel: '' }
        }
      },
      changePwd: {
        placeholder: {
          newPwd: '请输入新密码',
          checkPwd: '请再次输出新密码'
        },
        value: { email: '', code: '', newPwd: '', checkPwd: '' },
        state: false
      },
      deleteAccount: {
        value: '',
        confirmText: '我确认注销用户'
      },
      defaultInfo: {
        newPwdPlaceholder: '请输入新密码',
        checkPwdPlaceholder: '请再次输出新密码'
      }
    }
  },
  mounted() {
    this.$Common.SetDocTitle(this)
    this.GetUserInfo()
  },
  beforeUnmount() {
    if (this.jumpTimer) {
      clearInterval(this.jumpTimer)
      this.jumpTimer = null
    }
  },
  methods: {
    FormatDate(dateStr) {
      if (!dateStr) return '未知'
      const date = new Date(dateStr)
      const pad = (n) => n < 10 ? '0' + n : n
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    },
    GetUserInfo() {
      // 尝试从 localStorage 获取用户信息
      // 注意：这里假设父组件或全局状态中有用户信息，或者再次调用 API
      // 简单起见，这里假设 Token 有效，直接读取存储的用户名或重新请求
      // 由于 Index.vue 中已经请求过 UserInfo，我们可以尝试从 localStorage 读取
      // 但实际上 Index.vue 并没有把 userInfo 存到 localStorage，只存了 token
      // 所以我们需要再次请求 UserInfo 接口
      this.$Common.ApiList(this, 'UserInfo').then(url => {
        this.axios.get(url).then(res => {
          if (res.data.code === 200) {
            this.userInfo = res.data.data
          }
        })
      })
    },
    ShowChangePwdDialog() {
      this.changePwd.value = { 
        email: this.userInfo.email || '', 
        code: '', 
        newPwd: '', 
        checkPwd: '' 
      }
      this.changePwd.state = false
      this.control.dialog = {
        state: true,
        title: '修改密码',
        name: 'ChangePwd',
        icon: '/icon/password.svg',
        buttonName: { accept: '提交修改', cancel: '取消' },
        accept: () => { this.SubmitChangePwd() }
      }
      this.$nextTick(() => { 
        if(this.$refs.NewPwd) this.$refs.NewPwd.focus() 
      })
    },
    SendResetCode: function () {
      const email = this.changePwd.value.email
      if (!email) {
        this.$Common.ShowToast(this, '请输入邮箱信息', 'warning')
        return
      }
      if (this.countdown > 0) return

      this.$Common.ApiList(this, 'SendCode').then(url => {
        this.$Common.SetLoading('正在发送验证码...')
        this.axios.get(url, { params: { email }, timeout: 60000 }).then(res => {
          this.$Common.RemoveLoading()
          if (res.data.code === 200) {
            this.StartCountdown()
            this.$Common.ShowToast(this, '验证码已发送', 'success')
          } else {
            this.$Common.ShowToast(this, res.data.message || '发送失败', 'warning')
          }
        }).catch(() => {
          this.$Common.RemoveLoading()
          this.$Common.NetworkErrorDialog(this)
        })
      })
    },
    StartCountdown: function () {
      this.countdown = 60
      if (this.timer) clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    KeydownEnter_ChangePwd(event) {
      // 简单的焦点切换逻辑
      const input = event.target
      if (input === this.$refs.NewPwd) {
        this.$refs.CheckPwd.focus()
      } else if (input === this.$refs.CheckPwd) {
        this.SubmitChangePwd()
      }
    },
    SubmitChangePwd() {
      const { email, code, newPwd, checkPwd } = this.changePwd.value
      
      if (!email) {
        this.$Common.ShowToast(this, '请输入邮箱信息', 'warning')
        return
      }
      if (!code || !newPwd) {
        this.$Common.ShowToast(this, '验证码和新密码不能为空', 'warning')
        return
      }
      if (newPwd !== checkPwd) {
        this.$Common.ShowToast(this, '两次新密码输入不一致', 'warning')
        return
      }
      
      this.$Common.SetLoading('正在修改密码...')
      this.$Common.ApiList(this, 'ChangePwd').then(url => {
        // Backend expects ResetPasswordRequest: { email, password, code }
        const payload = {
          email: email,
          password: newPwd,
          code: code
        }
        this.axios.post(url, payload).then(res => {
          this.$Common.RemoveLoading()
          if (res.data.code === 200) {
            this.control.dialog = {
              state: true,
              title: '修改成功',
              name: 'PwdChangeSuccess',
              icon: '/icon/success.svg',
              content: '密码修改成功，3秒后自动跳转登录页',
              buttonName: { accept: '立即跳转', cancel: '' },
              accept: () => { this.JumpToLogin() }
            }
            
            let seconds = 3
            this.jumpTimer = setInterval(() => {
              seconds--
              this.control.dialog.content = `密码修改成功，${seconds}秒后自动跳转登录页`
              if (seconds <= 0) {
                this.JumpToLogin()
              }
            }, 1000)
          } else {
            this.$Common.ShowToast(this, res.data.message || '修改失败', 'warning')
          }
        }).catch(() => {
          this.$Common.RemoveLoading()
          this.$Common.NetworkErrorDialog(this)
        })
      })
    },
    JumpToLogin() {
      if (this.jumpTimer) {
        clearInterval(this.jumpTimer)
        this.jumpTimer = null
      }
      this.control.dialog.state = false
      localStorage.removeItem('token')
      this.$router.push('/Login')
    },
    ShowDeleteAccountDialog() {
      this.deleteAccount.value = ''
      this.control.dialog = {
        state: true,
        title: '注销账号',
        name: 'DeleteAccount',
        icon: '/icon/delete.svg',
        buttonName: { accept: '确认注销', cancel: '取消' },
        accept: () => { this.SubmitDeleteAccount() }
      }
    },
    SubmitDeleteAccount() {
      if (this.deleteAccount.value !== this.deleteAccount.confirmText) {
        this.$Common.ShowToast(this, '输入内容不正确，无法注销', 'warning')
        return
      }
      
      this.$Common.SetLoading('正在注销账号...')
      this.$Common.ApiList(this, 'DeleteAccount').then(url => {
        this.axios.delete(url).then(res => {
          this.$Common.RemoveLoading()
          if (res.data.code === 200) {
            this.$Common.ShowToast(this, '账号已注销', 'success')
            this.JumpToLogin()
          } else {
            this.$Common.ShowToast(this, res.data.message || '注销失败', 'warning')
          }
        }).catch(() => {
          this.$Common.RemoveLoading()
          this.$Common.NetworkErrorDialog(this)
        })
      })
    }
  }
}
</script>

<style scoped>
.Profile {
  padding: 20px;
  background: #fff;
  height: 100%;
  box-sizing: border-box;
}
.Header {
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
  padding-bottom: 10px;
}
.Section {
  margin-bottom: 30px;
}
.SectionTitle {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  border-left: 4px solid var(--ccs-primary-color);
  padding-left: 10px;
}
.InfoItem {
  padding: 10px 0;
  border-bottom: 1px solid #f5f5f5;
}
.Label {
  color: #666;
  width: 80px;
  display: inline-block;
}
.Value {
  color: #333;
  font-weight: 500;
}
.ActionItem {
  display: flex;
  align-items: center;
  padding: 15px 10px;
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
  transition: background 0.2s;
}
.ActionItem:hover {
  background: #f9f9f9;
}
.ActionIcon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.ActionItem span {
  flex: 1;
  color: #333;
}
.Dialog_ChangePwd {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.Dialog_ChangePwd input {
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 4px;
}
.SendCodeBtn {
  padding: 0 15px;
  background: var(--ccs-primary-color);
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.3s, opacity 0.3s;
  white-space: nowrap;
}
.SendCodeBtn:hover {
  opacity: 0.9;
}
.SendCodeBtn:disabled {
  background: #ccc;
  cursor: not-allowed;
  opacity: 0.7;
}

.Dialog_DeleteAccount {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.Dialog_DeleteAccount input {
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 4px;
}
.WarningText {
  color: #f56c6c;
  font-size: 14px;
  margin-bottom: 5px;
}
</style>